<template>
    <div class="inline-flex items-center">
        <button
            @click.prevent="copyText"
            class="ml-2 p-2 rounded hover:bg-gray-100 transition duration-300 ease-in-out has-tooltip">
            <i :class="[
                    'w-5 h-5',
                    'text-xl',
                    'transition duration-300 ease-in-out',
                    copied ? 'ph-check' : 'ph-copy-simple',
                    copied ? 'text-green-500' : 'text-gray-600'
                ]"/>
            <span class="tooltip">{{tooltipText}}</span>
        </button>
    </div>
</template>

<script setup>
import {ref} from 'vue'

const props = defineProps({
    target: {
        type: String,
        required: true,
    },
    tooltipText: {
        type: String,
        default: 'Copy'
    }
})

const copied = ref(false)

const copyText = async () => {
    const target = document.getElementById(props.target)
    if (target && target.value) {
        await navigator.clipboard.writeText(target.value)
        copied.value = true
        setTimeout(() => {
            copied.value = false
        }, 2000)
    }
}
</script>
